<template>
  <div>
    <b-alert
        v-if="error"
        variant="danger"
        show
        dismissible
    >
      {{ error }}
    </b-alert>

    <b-card v-if="client">
      <b-tabs pills card>
        <b-tab title="Informations" active>
          <clients-edit-client-tab-information
              :client="client"
              @submit="saveClient"
          />
        </b-tab>

<!--        <b-tab title="Projets">-->
<!--          <client-edit-tab-projects-->
<!--              :client="client"-->
<!--              :projects="clientProjects"-->
<!--              :loading="loading"-->
<!--          />-->
<!--        </b-tab>-->
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ClientsEditClientTabInformation from './ClientsEditClientTabInformation.vue'
import ClientsEditClientTabProjects from './ClientsEditClientTabProjects.vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {BAlert, BCard, BTab, BTabs} from "bootstrap-vue";

export default {
  name: 'ClientEdit',
  components: {
    BTab,
    BTabs,
    BAlert,
    BCard,
    ClientsEditClientTabInformation,
    // ClientsEditClientTabProjects,
  },
  data() {
    return {
      error: null,
    }
  },
  computed: {
    ...mapState('client', ['client', 'clientProjects', 'clientPayments', 'loading']),
    clientId() {
      return this.$route.params.id
    },
  },
  created() {
    this.fetchClient()
  },
  methods: {
    async fetchClient() {
      try {
        await this.$store.dispatch('client/fetchClient', {id: this.clientId})
      } catch (error) {
        this.error = "Erreur lors du chargement du client"
      }
    },
    async saveClient(client) {
      try {
        await this.$store.dispatch('client/updateClient', {
          id: this.clientId,
          data: client,
        })
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Client mis à jour avec succès",
            icon: "CoffeeIcon",
            variant: "success",
          },
        });
      } catch (error) {
        this.error = "Erreur lors de la mise à jour du client."
      } finally {
        await this.$router.push({name: 'apps-client-view', params: {id: this.clientId}})
      }
    },
  },
}
</script>